import { Select as UiSelect } from "@rumbledirect/ui";
import { QuestionDropdownModel } from "survey-core";
import { createStyles } from "antd-style";

const styleUtils = createStyles(({ css }) => ({
  select: css`
      .ant-select-content input[readonly] {
        border: none !important;
      }

      .ant-select-content-value {
        white-space: normal;
      }
    `,
  selectPopup: css`
      .ant-select-item-option-content {
        white-space: normal;
      }
    `,
}));

export const SelectQuestion = (props: { question: QuestionDropdownModel }) => {
  const { styles } = styleUtils();

  const options = props.question.visibleChoices.map((c: any) => ({
    value: c.value,
    label: c.text,
  }));

  const onSelectChange = (value: string) => {
    props.question.value = value;
  };

  const isLoading = props.question.choicesByUrl?.isRunning ?? false;

  return (
    <UiSelect
      className={styles.select}
      classNames={{ popup: { root: styles.selectPopup } }}
      styles={{ root: { fontWeight: 500 } }}
      options={options}
      style={{ width: "100%" }}
      id={props.question.inputId}
      value={props.question.value}
      placeholder={props.question.locPlaceholder.getLocaleText("")}
      disabled={
        props.question.isDisabledAttr || props.question.isReadOnly || isLoading
      }
      onBlur={(e) => props.question.onBlur(e)}
      onFocus={(e) => props.question.onFocus(e)}
      onChange={onSelectChange}
      allowClear={!props.question.isRequired}
      onClick={props.question.readOnlyBlocker}
      loading={isLoading}
      onKeyUp={props.question.onKeyUp}
      onKeyDown={props.question.onKeyDown}
      aria-required={props.question.a11y_input_ariaRequired}
      aria-label={props.question.a11y_input_ariaLabel}
      aria-labelledby={props.question.a11y_input_ariaLabelledBy}
      aria-describedby={props.question.a11y_input_ariaDescribedBy}
      aria-invalid={props.question.a11y_input_ariaInvalid}
      aria-errormessage={props.question.a11y_input_ariaErrormessage}
    />
  );
};
